"use client";
import React, { useEffect, useState } from "react";
import AdsBanner from "@/components/ads-banner";
import { useDispatch, useSelector } from "react-redux";
import { getDetailByID, getDetailBySlug, initialBookStateFromStorage, setBookStateToStorage } from "@/redux/reducers/book.reducer";
import MediaTabs from "./components/book-tabs";
import { useAuth } from "@/hooks";
import coinAPI from "@/services/coin_api";
import BookInfo from "./components/book-info";
import { definitions } from "@/services/metruyenvl";
import { AppDispatch, RootState } from "@/redux/store";
import readAPI from "@/services/read_api";
import { ResponseTypes } from "@/types/constants";
import bookAPI from "@/services/book_api";
import { userInfo } from "@/redux/reducers/user.reducer";
import useDeepCompareEffect from "use-deep-compare-effect";

function BookBody({ slug }: { slug: string }) {
    const dispatch = useDispatch<AppDispatch>();
    const bookData = useSelector((state: RootState) => state.bookReducer?.map[slug]);
    const userData = useSelector(userInfo);

    useEffect(() => {
        // Dispatch action to load state from localStorage
        if (!bookData || !bookData.detail) {
            dispatch(initialBookStateFromStorage(slug));
        }

        if (!bookData || !bookData.detail?.id) {
            dispatch(getDetailBySlug({ slug: slug }));
        }

        console.log("useEffect BookBody initialBookStateFromStorage - slug: ", slug, ", bookData: ", bookData);
    }, [dispatch, slug, userData?.settings?.save_offline]);

    useDeepCompareEffect(() => {
        if (!!bookData && !!bookData.detail && userData?.settings?.save_offline) {
            dispatch(setBookStateToStorage(slug));
        }
    }, [dispatch, bookData, userData?.settings?.save_offline]);

    return (
        <div className="relative w-full md:mt-[-80px] 2xl:mt-[-120px] md:rounded-lg md:p-4 bg-white max-w-[1200px] mx-auto">
            <BookInfo slug={slug} />
            <MediaTabs slug={slug} />
            {/* <AdsBanner /> */}
        </div>
    );
}

export default BookBody;
